import React from 'react';

export const VerticalDotsIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			aria-hidden='true'
			fill='none'
			focusable='false'
			height={props.height}
			role='presentation'
			viewBox='0 0 24 24'
			width={props.width}
			{...props}
		>
			<path
				d='M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
				fill='currentColor'
			/>
		</svg>
	);
};
